import { Redacted, Schema } from "effect";
import { privateDependencyFailure } from "@workerstation/shared/errors/private-cause";

export const KVClipboardSnapshot = Schema.Struct({
  text: Schema.String,
  copied: Schema.Boolean,
  refused: Schema.Boolean
});
export type KVClipboardSnapshot = typeof KVClipboardSnapshot.Type;
export class KVClipboardFailure extends privateDependencyFailure<KVClipboardFailure>()("KVClipboardFailure", "clipboard") {}
export const kvClipboardFailure = (cause: unknown) => new KVClipboardFailure({ cause: Redacted.make(cause) });
export const clipboardResetMs = 1500;
